/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type UpdateBookingSitePayload = {
    title?: string | null;
    categoryIds?: Array<number>;
    layout?: UpdateBookingSitePayload.layout;
    active?: boolean;
    showAddress?: boolean;
    requireEmailConfirmation?: boolean;
};
export namespace UpdateBookingSitePayload {
    export enum layout {
        COMPACT = 'compact',
        EXTENDED = 'extended',
    }
}

